import { Store } from "../../store";

// Presentation only: the API independently enforces the current database mode.
export const isDemoAccount = (): boolean => Store.accountMode === "demo";
